import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import ReactDOM from 'react-dom';
import { faWarning, faClose } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import './index.scss';
import Button from '../../../elements/button';

type Props = {
  errorMessage: string;
  onCancel: () => void;
};

function ErrorModal({ errorMessage, onCancel }: Props) {
  const { t } = useTranslation();
  const container = document.body;

  const escListener = (event: KeyboardEvent) => {
    event.keyCode === 27 && onCancel();
  };

  useEffect(() => {
    window.addEventListener('keyup', escListener);
    return () => {
      window.removeEventListener('keyup', escListener);
    };
  });

  return (
    container && (
      <React.Fragment>
        {ReactDOM.createPortal(
          <div className="error-modal" data-testid="error-modal">
            <div className="error-modal__backdrop" onClick={onCancel}></div>
            <div className="error-modal__content-area">
              <div className="error-modal__header">
                <FontAwesomeIcon className="error-modal__close-icon" icon={faClose} onClick={onCancel} />
              </div>
              <div className="error-modal__body">
                <FontAwesomeIcon className="error-modal__warning-icon" icon={faWarning} />
                <p className="text-small--regular" data-testid="error-message">
                  {errorMessage}
                </p>
              </div>
              <div className="error-modal__footer">
                <Button className="error-modal__confirm-btn text-medium--bold" onClick={onCancel}>
                  {t('auth.errorModalClose')}
                </Button>
              </div>
            </div>
          </div>,
          container,
        )}
      </React.Fragment>
    )
  );
}

export default ErrorModal;
